import React from 'react';

const QuoteButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="bg-red-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-red-700 transition-colors duration-300 shadow-md hover:shadow-lg"
  >
    Get Free Quote!
  </button>
);

export default QuoteButton;